import script from "./production.vue?vue&type=script&setup=true&lang=js"
export * from "./production.vue?vue&type=script&setup=true&lang=js"

import "./production.vue?vue&type=style&index=0&id=49af4f7b&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49af4f7b"]])

export default __exports__